<rt-dialog-header>
  <div layout-full-width>
    <div layout layout-space-between>
      <rt-heading variant="heading large-x-dialog-header">
        {{ translationKey.dialog_2fa_app.step_1.header | translate }}
      </rt-heading>
      <span layout layout-align-items-center margin-left-auto>
        {{ translationKey.dialog_2fa_app.step_1.header_step | translate }}
      </span>
    </div>
    <span>{{ translationKey.dialog_2fa_app.step_1.header_description | translate }}</span>
  </div>
</rt-dialog-header>
<rt-dialog-body variant="white">
  <div layout-vertical>
    <span [innerHTML]="translationKey.dialog_2fa_app.step_1.description | translate"></span>
    <div margin-right-auto margin-left-auto layout-horizontal>
      <img
        ngSrc="assets/images/security/two-factor-auth-illustration.png"
        [width]="640"
        [height]="360"
        [alt]="translationKey.dialog_2fa_app.step_1.picture_alt | translate"
      />
    </div>
  </div>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button (click)="cancel.emit()" variant="plain">{{
    translationKey.common.cancel | translate
  }}</rt-button>
  <rt-button (click)="goNext.emit()" variant="primary">
    {{ translationKey.common.continue | translate }}
  </rt-button>
</rt-dialog-footer>
